import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/app/config/config';

@Injectable({
  providedIn: 'root'
})
export class ItineraryService {
  private pathApi = this.config.setting['pathApi'] + "itinerary/";

  constructor(private http: HttpClient, private config: AppConfig) { }

  get(id: any): Observable<any> {
    return this.http.get(`${this.pathApi}${id}`);
  }
  
  getAll(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, obj);
  }


  delete(id: number): Observable<any> {
    return this.http.delete(`${this.pathApi}delete/${id}`);
  } 

  uploadFile(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}uploadFile`, obj);
  }

  getTemplate(): Observable<any>{
    return this.http.get(`${this.pathApi}getTemplate`);
  }

  getItinerariesForOptions(): Observable<any> {
    return this.http.get(`${this.pathApi}getItinerariesForOptions`);
  }

  getItineraryForOptionsByRoute(routeId: number): Observable<any> {
    return this.http.get(`${this.pathApi}getItineraryForOptionsByRoute/${routeId}`);
  }
}
